import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
var PlTabNavigation = function (_a) {
    var elements = _a.elements, selectedValue = _a.selectedValue, onChangeElement = _a.onChangeElement;
    return (_jsx("div", { className: "flex items-center gap-2", children: elements.map(function (e) {
            var isSelected = e.value === selectedValue;
            var onElementClick = function () { return onChangeElement(e.value); };
            return (_jsx("button", { className: "py-2 px-3 rounded-full text-[14px] ".concat(isSelected ? 'bg-orange-dark font-medium text-white' : 'text-grey'), onClick: onElementClick, children: e.label }, e.value));
        }) }));
};
export default PlTabNavigation;
